/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React from "react";
import {
  Typography,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { mixpanelBase } from "app/common/MixpanelComponent";
import useFormFields from "lib/forms";
import { sortBy as _sortBy } from "lodash";
import { useDispatch } from "react-redux";
import { setTenant } from "../duck/slices";

const useStyles = makeStyles(() => ({
  formButton: {
    marginTop: "20px",
  },
}));

const TenantSelectorForm = ({
  setIsLoading,
  setAlertMessage,
  tenants = [],
}) => {
  const classes = useStyles();
  const [fields, handleFieldChange] = useFormFields({
    tenant: "",
  });
  const dispatch = useDispatch();

  function handleTenantSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    if (!fields.tenant) {
      setAlertMessage("You need to choose a data instance to continue");
      return;
    }
    mixpanelBase({ [`data_instance`]: fields.tenant?.mysql_database });
    dispatch(setTenant(fields.tenant));
    setIsLoading(false);
  }

  return tenants.length ? (
    <form onSubmit={handleTenantSubmit}>
      <FormControl
        fullWidth
        required
        variant="outlined"
        className={classes.formControl}
      >
        <InputLabel id="tenant-select-label">Data Instance</InputLabel>
        <Select
          labelId="tenant-select-label"
          value={fields.tenant}
          name="tenant"
          onChange={handleFieldChange}
          label="Data Instance"
        >
          <MenuItem value="" disabled>
            Select a data instance
          </MenuItem>
          {_sortBy(tenants, ["company.name", "company.short_name"]).map(
            (tenant) => {
              return (
                <MenuItem
                  style={{ display: "flex", alignItems: "baseline" }}
                  key={tenant.id}
                  value={tenant}
                >
                  <Typography variant="body1" display="inline">
                    {tenant.company.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="inline"
                    style={{ marginLeft: 5 }}
                  >
                    {`- ${tenant.company.short_name}`}
                  </Typography>
                </MenuItem>
              );
            }
          )}
        </Select>
      </FormControl>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.formButton}
      >
        Select data and proceed
      </Button>
    </form>
  ) : (
    <Typography variant="body1" align="center">
      No data instances to select
    </Typography>
  );
};

export default TenantSelectorForm;
